import Link from 'next/link'
import { useRouter } from "next/router";

import { Popover } from '@douyinfe/semi-ui';

import cName from 'classnames';
import styles from "./styles.module.scss";

import { useTranslations } from "next-intl";

export default ({ }) => {
  const router = useRouter()
  const t = useTranslations("footer");

  return (
    <footer className={styles.footer}>
      <div className={cName(styles.top, 'm-1600')}>
        <div className={styles.left}>
          <Link href="/">
            <img className={styles.logo} src="/image/footer-logo-2027.png" alt="" />
          </Link>
          <Link href="/">
            <a className={styles.title}>{t("top.left.title")}</a>
          </Link>
          <div className={styles.info}>
            <span className={styles.date}>{t("top.left.date")}</span>
            <span className={styles.address}>{t("top.left.address")}</span>
          </div>
        </div>
        <i className={styles.line}></i>
        <div className={styles.middle}>
          <p className={styles.title}>{t("top.middle.title")}</p>
          <ul className={styles.list}>
            <li><Link href="/about/survey"><a>{t("top.middle.item1tit")}</a></Link></li>
            <li><Link href={`https://cbce2025.expotec-group.com/?exhibitor/login${router.locale == 'en' ? '&lang=en' : ''}`}><a target="_blank">{t("top.middle.item2tit")}</a></Link></li>
            <li><Link href={`https://cbce2025.expotec-group.com/?member/register${router.locale == 'en' ? '&lang=en' : ''}`}><a target="_blank">{t("top.middle.item3tit")}</a></Link></li>
            <li><Link href="/summit/2025"><a>{t("top.middle.item4tit")}</a></Link></li>
            <li><Link href="/schedule"><a>{t("top.middle.item5tit")}</a></Link></li>
            <li><Link href="/media/news"><a>{t("top.middle.item6tit")}</a></Link></li>
            <li><Link href="/contacts"><a>{t("top.middle.item7tit")}</a></Link></li>
            <li><Link href="/privacypolicy"><a>{t("top.middle.item8tit")}</a></Link></li>
          </ul>
        </div>
        <i className={styles.line}></i>
        <div className={styles.right}>
          <p className={styles.title}>{t("top.right.title")}</p>
          <ul className={cName(styles.list, router.locale == 'en' ? styles.en : '')}>
            <li className={styles.wx_account}>
              <Popover
                position="top"
                content={
                  <img style={{ width: '150px' }} src="/image/wx-account-qr.png" alt="" />
                }
              >
                <img src="https://img.cbcechina.com/2026-07-28/76449864bc43068853f648a3aa659a82.png" alt="" />
              </Popover>
            </li>
            <li className={styles.douyin}>
              <Link href="https://v.douyin.com/NFXodmxAHkc/ 9@0.com">
                <a target="_blank">
                  <img src="https://img.cbcechina.com/2026-07-28/c040303a65610a2e3f8e5e6bddc00073.png" alt="" />
                </a>
              </Link>
            </li>
            <li className={styles.xiaohongshu}>
              <Link href="https://www.xiaohongshu.com/user/profile/5f5cccbb000000000101d16c?xsec_token=YB_XNj9ey4eGBDnITikPc6BsIHvf8GG6Cd67CqbHFTkQQ=&xsec_source=app_share&xhsshare=CopyLink&appuid=5f5cccbb000000000101d16c&apptime=1754291150&share_id=a16d9bc498994075864959d8d8250075">
                <a target="_blank">
                  <img src="https://img.cbcechina.com/2026-07-28/ebaec80bf15a40354fddbddcae61732a.png" alt="" />
                </a>
              </Link>
            </li>
            <li className={styles.wx_applet}>
              <Popover
                position="top"
                content={
                  <img style={{ width: '150px' }} src="/image/wxqr.jpg" alt="" />
                }
              >
                <img src="https://img.cbcechina.com/2026-07-28/eafbd7d467b871af87dfb34705946ffa.png" alt="" />
              </Popover>
            </li>
            <li className={styles.linkedin}>
              <Link href="https://www.linkedin.com/company/craft-beer-china/">
                <a target="_blank">
                  <img src="https://img.cbcechina.com/2026-07-28/5412ecda565fb5e1affdf33c2dd4dccf.png" alt="" />
                </a>
              </Link>
            </li>
            <li className={styles.facebook}>
              <Link href="https://www.facebook.com/profile.php?id=61588897982069">
                <a target="_blank">
                  <img src="https://img.cbcechina.com/2026-07-28/b89637670f4f58bb19bfcdb09cdcf9fa.png" alt="" />
                </a>
              </Link>
            </li>
            <li className={styles.twitter}>
              <Link href="https://x.com/CraftBeer666">
                <a target="_blank">
                  <img src="https://img.cbcechina.com/2026-07-28/6de5ebd3fb4f8abbc117492c5e4dba55.png" alt="" />
                </a>
              </Link>
            </li>
            <li className={styles.youtube}>
              <Link href="https://www.youtube.com/@CraftBeerChina">
                <a target="_blank">
                  <img src="https://img.cbcechina.com/2026-07-28/175ca5f2471e59aed57b7b2ab4de37d9.png" alt="" />
                </a>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={cName(styles.inner, 'm-1600')}>
          <div className={styles.left}>
            <Link href="https://www.nm-china.com.cn/">
              <a target="_blank">{t("bottom.left.item1tit")}</a>
            </Link>
            <Link href="https://beian.miit.gov.cn/">
              <a target="_blank">{t("bottom.left.item2tit")}</a>
            </Link>
          </div>
          <div className={styles.right}>
            <div className={styles.item}>
              <span>{t("bottom.right.item1tit")}</span>
              <img src="/image/messe-logo.png?v=202509051028" alt="" />
              <img src="/image/beer.png" alt="" />
            </div>
            <div className={styles.item}>
              <span>{t("bottom.right.item2tit")}</span>
              <Link href="https://www.smartinfo.cn/">
                <a target="_blank">{t("bottom.right.item2txt")}</a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
